import { base64Decode, base64Encode, isBase64 } from '../utils/base64';
import { Item } from './Item';
import { Person } from './Person';

export enum MessageType {
  NOTIFICATION = 'NOTIFICATION',
  CLASS_ANNOUNCEMENT = 'CLASS_ANNOUNCEMENT',
  DM = 'DM',
}

export enum NotificationType {
  CHALLENGE_CODE = 'CHALLENGE_CODE',
  WELCOME = 'WELCOME',
  ASSIGNMENT_AVAILABLE = 'ASSIGNMENT_AVAILABLE',
  ASSIGNMENT_DUE_IN_3_DAYS = 'ASSIGNMENT_DUE_IN_3_DAYS',
  ASSIGNMENT_DUE_IN_3_HOURS = 'ASSIGNMENT_DUE_IN_3_HOURS',
  ASSIGNMENT_INSTRUCTOR_SYNOPSIS = 'ASSIGNMENT_INSTRUCTOR_SYNOPSIS',
  ENROLLMENT = 'ENROLLMENT',
  UNENROLLMENT = 'UNENROLLMENT',
}

export interface Message extends Item {
  messageType: MessageType;
  notificationType?: NotificationType;

  toId: number;
  to?: Person;

  fromId?: number;
  from?: Person;
  fromEmail: string;

  subject: string;
  text: string;
  html: string;
  readAt?: Date;
  emailHtml?: string;
  emailText?: string;
}

export const translateMessageForTransport = (attributes: any): any => {
  const { html, emailHtml } = attributes;
  return {
    ...attributes,
    html: !isBase64(html) ? base64Encode(html) : html,
    emailHtml: !isBase64(emailHtml) ? base64Encode(emailHtml) : emailHtml,
  };
};

export const translateMessageFromTransport = (attributes: any): any => {
  const { html, emailHtml } = attributes;
  return {
    ...attributes,
    html: isBase64(html) ? base64Decode(html) : html,
    emailHtml: isBase64(emailHtml) ? base64Decode(emailHtml) : emailHtml,
  };
};
